import Factory from './libs/factory';

window.xapi = Factory;
